import { useState } from "react";
import {
  checkMissingChecksumCount,
  fetchBeatmapsetById,
  fetchBeatmapsets,
  fixMissingChecksums,
} from "../../../service/BeatmapsService";
import { useUserStore } from "../../../store/userStore";
import { useShallow } from "zustand/react/shallow";

const FixChecksums = () => {
  const authToken = useUserStore(useShallow((state) => state.authToken));
  const [beatmapsetId, setBeatmapsetId] = useState<number>(0);
  // const [responseMessage, setResponseMessage] = useState<string>("");
  const [isSuccessful, setIsSuccessful] = useState<boolean>(true);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [nullCount, setNullCount] = useState<number>(0);

  const checkMissingBeatmapsChecksumsCount = async () => {
    if (authToken === undefined) {
      alert("authorize first!");
      setIsFetching(false);
      return;
    }

    setIsFetching(true);

    try {
      const resp = await checkMissingChecksumCount();
      setNullCount(resp.count);
      setIsSuccessful(resp.count >= 0 ? true : false);
    } catch {
      setIsSuccessful(false);
    } finally {
      setIsFetching(false);
    }
  };

  const fixBeatmapsChecksums = async () => {
    if (authToken === undefined) {
      alert("authorize first!");
      setIsFetching(false);
      return;
    }

    // if (!beatmapsetId) {
    //   alert("set beatmapsetID first!");
    //   setIsFetching(false);
    //   return;
    // }

    setIsFetching(true);
    let remainingCount: number = nullCount;

    while (remainingCount > 0) {
      try {
        const resp = await fixMissingChecksums(authToken);
        remainingCount = resp.remainingCount;
        setNullCount(resp.remainingCount);
        setIsSuccessful(resp.remainingCount >= 0 ? true : false);
      } catch {
        setNullCount(-1);
      } finally {
      }
    }
    setIsFetching(false);
  };

  return (
    <div>
      <div className="main-page_menu-element">
        <button
          className="btn btn-primary"
          disabled={authToken === undefined || isFetching === true}
          onClick={checkMissingBeatmapsChecksumsCount}
        >
          Check missing checksums count
        </button>
        <button
          className="btn btn-primary mx-2"
          disabled={authToken === undefined || isFetching === true}
          onClick={fixBeatmapsChecksums}
        >
          Fix missing
        </button>
      </div>
      <div></div>
      <p style={{ color: "white" }}>count: {nullCount}</p>
    </div>
  );
};

export default FixChecksums;
